/**
 * 详情页和列表页的链接有字符串和json字符串两种形式，此函数用于解析输入的URL是何种形式的字符串
 * @param {string} url
*/
export function linkUrlJsonString(url = '') {
    let linkUrl = url.replace(/\s/g, '');
    const linkUrlSplitArray = linkUrl.split('');
    if (linkUrlSplitArray[0] === '{' && linkUrlSplitArray[linkUrlSplitArray.length - 1] === '}') {
        // 给输入的key做忽略大小写处理
        const urlReg = /(url)/i;
        const hasShadowContextReg = /(hasShadowContext)/i;
        linkUrl = urlReg.test(linkUrl) ? linkUrl.replace(urlReg, 'url') : false;
        if (linkUrl) {
            linkUrl = hasShadowContextReg.test(linkUrl) ? linkUrl.replace(hasShadowContextReg, 'hasShadowContext') : linkUrl;
            return JSON.parse(linkUrl.replace(/'/g, '"'));
        }else{
            return '';
        }
    }
    return linkUrl;
}


// WEBPACK FOOTER //
// ./src/components/util/linkUrlJsonString.js